import { useCallback } from 'react';

import { BaseQueryParams } from '@/shared/api';

import { useCreateConsignmentMutation } from '../api/consignmentsApi';
import type { ConsignmentCreateRequest } from './types';

export interface UseCreateConsignmentOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: unknown) => void;
}

export const useCreateConsignment = (options?: UseCreateConsignmentOptions) => {
  const [createConsignment, { isLoading, isSuccess, isError, error, data }] = useCreateConsignmentMutation();

  const handleCreate = useCallback(
    async (params: BaseQueryParams, data: ConsignmentCreateRequest) => {
      try {
        const response = await createConsignment({
          ...params,
          ...data
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [createConsignment, options]
  );

  return {
    createConsignment: handleCreate,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
